<template>
    <VJoyButton
        v-if="hasLocale"
        variant="ghost"
        size="small"
        data-testid="locale-selection-button"
        class="unlogged-navbar__locale-selection-button has-locale"
        :aria-label="$t('navbar.feat.locale-selection.dialog.language.select.label')"
        :disabled="loading"
    >
        <VJoyWrapper align="center" justify="center" column-gap="2" wrap="nowrap" no-margin>
            <VJoyIcon size="small" :name="iconName" />
            {{ locale }}
        </VJoyWrapper>
    </VJoyButton>
    <VJoyIconButton
        v-else
        variant="ghost"
        size="small"
        data-testid="locale-selection-button"
        class="unlogged-navbar__locale-selection-button"
        :label="$t('navbar.feat.locale-selection.dialog.cta.open')"
        :disabled="loading"
        :icon="iconName"
    />
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {useMouseHover} from '@malt/utils';
    import {VJoyButton, VJoyIcon, VJoyIconButton, VJoyWrapper} from '@maltjoy/core-vue';

    interface Props {
        loading?: boolean;
        locale?: string;
    }

    const {loading = false, locale} = defineProps<Props>();

    const {isHovering} = useMouseHover();
    const hasLocale = computed(() => !!locale);
    const iconName = computed(() => (isHovering.value ? 'globe-hover' : 'globe'));
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/text' as text;

    .unlogged-navbar__locale-selection-button {
        &.has-locale {
            border-radius: var(--joy-form-field-radius-xxsmall);
            padding: var(--button-padding, 0);

            @include mq.screen_sm(min) {
                padding: var(--button-padding, 0 var(--joy-core-spacing-3));
            }
        }

        &,
        * {
            @include text.getFontBySize(primary-400);

            color: var(--joy-color-neutral-60);
        }

        &.joy-button:focus {
            outline: var(--joy-core-spacing-0) solid var(--joy-color-neutral-40);
            outline-offset: -1px;
            border-color: transparent;
        }
    }
</style>
